import React, { useEffect, useState } from "react";

import { Form, Row, Col, Button, Alert, Modal } from "react-bootstrap";
import LabelWithAsterisk from "../helpers/LabelWithAsterisk ";
import aclService from "../services/aclService";
import awsService from "../services/awsService";
import Loading from "../components/Loading";
import { useStateContext } from "../contexts/ContextProvider";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";

const ClientForm = ({
  clientData,
  mode = "create",
  handleCloseModal,
  fetchClients,
}) => {
  console.log(clientData, "--cliendata---");
  const { currentColor, currentMode } = useStateContext();
  const navigate = useNavigate();
  const [clientGeo, setClientGeo] = useState(clientData?.clientGeo || "");
  const [AWSName, setAWSName] = useState(() => {
    if (
      !clientData ||
      !clientData.awsAccounts ||
      clientData.awsAccounts.length === 0
    ) {
      // Handle the case where clientData or awsAccounts is undefined or empty
      console.error("clientData or awsAccounts is undefined or empty");
      return ""; // Fallback to an empty string or any other default value
    } else if (!clientData.awsAccounts[0].awsId) {
      // Handle the case where awsId is missing
      console.error("AWS ID is missing for the first account");
      return ""; // Fallback to an empty string or any other default value
    }

    // If everything is fine, return the awsId
    return clientData.awsAccounts[0].awsId;
  });

  const [clientLocation, setClientLocation] = useState(
    clientData?.clientLocation || ""
  );
  const [AWS, setAWS] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    clientName: clientData?.clientName || "",
    clientAddress: clientData?.clientAddress || "",
    clientCode: clientData?.clientCode || "",
    clientContact: clientData?.clientContact || "",
    clientContactEmail: clientData?.clientContactEmail || "",
    clientVertical: clientData?.clientVertical || "",
  });
  const [errors, setErrors] = useState({
    clientCode: "",
  });

  const geoOptions = ["Geo1", "Geo2", "Geo3"];
  const locationOptions = {
    Geo1: ["Location1-1", "Location1-2"],
    Geo2: ["Location2-1", "Location2-2"],
    Geo3: ["Location3-1", "Location3-2"],
  };
  const verticalOptions = ["Vertical1", "Vertical2", "Vertical3"];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (name === "clientCode" && value.length >= 3) {
      setErrors({ ...errors, clientCode: "" });
    }
  };

  const handleGeoChange = (e) => {
    const value = e.target.value;
    setClientGeo(value);
    setClientLocation(""); // Reset client location when geo changes
  };

  const handleAWSId = (e) => {
    const value = e.target.value;
    setAWSName(value);
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);
      let valid = true;
      let newErrors = { clientCode: "" };
      console.log(formData);
      if (formData.clientCode.length < 3) {
        valid = false;
        newErrors.clientCode =
          "Client Code must be at least 3 characters long.";
      }

      setErrors(newErrors);

      if (valid) {
        if (mode === "create") {
          const client_create = await aclService.clientCreate(formData);

          if (client_create && client_create.success) {
            toast.success("client created successfully", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            fetchClients();
            handleCloseModal();
            setLoading(false);
          } else {
            toast.error(
              client_create?.message ||
                "Error while creating client. Please try again",
              {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              }
            );
          }
          handleCloseModal();
          setLoading(false);
        } else {
          const client_update = await aclService.clientUpdate(
            clientData._id,
            formData
          );
          if (client_update && client_update.success) {
            toast.success("client Updated successfully", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            fetchClients();
            handleCloseModal();
            setLoading(false);
          } else {
            toast.error(
              client_update?.message ||
                "Error while Updating client. Please try again",
              {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              }
            );
          }
          handleCloseModal();
          setLoading(false);
        }
      }
      setLoading(false);
    } catch (error) {
      toast.error(
        "Error while creating client. Please try again after sometimes",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      setLoading(false);
      console.log(error);
    }
  };

  const handleCancel = async () => {
    navigate("/clientmanagement");
  };

  const fetchAws = async () => {
    try {
      const data = await awsService.getawss({});
      setAWS(data);
    } catch (error) {
      console.error("Error fetching AWS:", error);
    }
  };

  useEffect(() => {
    fetchAws();
  }, []);

  const isDisabled = (fieldName) => {
    if (mode === "edit") {
      return ![
        "clientAddress",
        "clientContact",
        "clientGeo",
        "clientLocation",
        "clientContactEmail",
        "clientVertical",
      ].includes(fieldName);
    }
    return false;
  };

  return (
    <>
      <Form
        onSubmit={handleSubmit}
        className={`pl-2 pr-2 pb-2 ${
          currentMode === "Dark" ? "text-white bg-[#33373E]" : "bg-white"
        }`}
      >
        <Row className="mb-0">
          <Col>
            <Form.Group
              controlId="formClientName"
              className="custom-form-group"
            >
              <Form.Label className="custom-form-label">
                <LabelWithAsterisk label="Client Name" />
              </Form.Label>
              <Form.Control
                type="text"
                name="clientName"
                value={formData.clientName}
                onChange={handleInputChange}
                required
                disabled={isDisabled("clientName")}
                className="custom-form-control"
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group
              controlId="formClientAddress"
              className="custom-form-group"
            >
              <Form.Label className="custom-form-label">
                <LabelWithAsterisk label="Client Address" />
              </Form.Label>
              <Form.Control
                type="text"
                name="clientAddress"
                value={formData.clientAddress}
                onChange={handleInputChange}
                required
                disabled={isDisabled("clientAddress")}
                className="custom-form-control"
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-0">
          <Col>
            <Form.Group
              controlId="formClientCode"
              className="custom-form-group"
            >
              <Form.Label className="custom-form-label">
                <LabelWithAsterisk label="Client Code" />
              </Form.Label>
              <Form.Control
                type="text"
                name="clientCode"
                value={formData.clientCode}
                onChange={handleInputChange}
                required
                disabled={isDisabled("clientCode")}
                className="custom-form-control"
              />
              {errors.clientCode && (
                <Alert variant="danger" className="mt-2">
                  {errors.clientCode}
                </Alert>
              )}
            </Form.Group>
          </Col>
          <Col>
            <Form.Group
              controlId="formClientContact"
              className="custom-form-group"
            >
              <Form.Label className="custom-form-label">
                <LabelWithAsterisk label="Client Contact" />
              </Form.Label>
              <Form.Control
                type="text"
                name="clientContact"
                value={formData.clientContact}
                onChange={handleInputChange}
                required
                disabled={isDisabled("clientContact")}
                className="custom-form-control"
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-0">
          <Col>
            <Form.Group controlId="formClientGeo" className="custom-form-group">
              <Form.Label className="custom-form-label">
                <LabelWithAsterisk label="Client Geo" />
              </Form.Label>

              <Form.Control
                as="select"
                name="clientGeo"
                value={clientGeo}
                onChange={(e) => {
                  handleGeoChange(e);
                  handleInputChange(e);
                }}
                required
                disabled={isDisabled("clientGeo")}
                className="custom-form-control"
              >
                <option value="">Select Geo</option>
                {geoOptions.map((geo, index) => (
                  <option key={index} value={geo}>
                    {geo}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Col>
          <Col>
            <Form.Group
              controlId="formClientLocation"
              className="custom-form-group"
            >
              <Form.Label className="custom-form-label">
                <LabelWithAsterisk label="Client Location" />
              </Form.Label>
              <Form.Control
                as="select"
                name="clientLocation"
                value={clientLocation}
                onChange={(e) => {
                  handleInputChange(e);
                  setClientLocation(e.target.value);
                }}
                disabled={!clientGeo || isDisabled("clientLocation")}
                required
                className="custom-form-control"
              >
                <option value="">Select Location</option>
                {clientGeo &&
                  locationOptions[clientGeo].map((location, index) => (
                    <option key={index} value={location}>
                      {location}
                    </option>
                  ))}
              </Form.Control>
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-0">
          <Col>
            <Form.Group
              controlId="formClientContactEmail"
              className="custom-form-group"
            >
              <Form.Label className="custom-form-label">
                <LabelWithAsterisk label="Client Contact Email" />
              </Form.Label>
              <Form.Control
                type="email"
                name="clientContactEmail"
                value={formData.clientContactEmail}
                onChange={handleInputChange}
                required
                disabled={isDisabled("clientContactEmail")}
                className="custom-form-control"
              />
            </Form.Group>
          </Col>

          <Col>
            <Form.Group
              controlId="formClientVertical"
              className="custom-form-group"
            >
              <Form.Label className="custom-form-label">
                <LabelWithAsterisk label="Client Vertical" />
              </Form.Label>
              <Form.Control
                as="select"
                name="clientVertical"
                value={formData.clientVertical}
                onChange={handleInputChange}
                required
                disabled={isDisabled("clientVertical")}
                className="custom-form-control"
              >
                <option value="">Select Vertical</option>
                {verticalOptions.map((vertical, index) => (
                  <option key={index} value={vertical}>
                    {vertical}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Col>
        </Row>

        {AWS && (
          <Row>
            <Col>
              <Form.Group
                controlId="formClientAWS"
                className="custom-form-group"
              >
                <Form.Label className="custom-form-label">
                  <LabelWithAsterisk label="AWS List" />
                </Form.Label>
                <Form.Control
                  as="select"
                  name="awsId"
                  value={AWSName}
                  onChange={(e) => {
                    handleInputChange(e);
                    handleAWSId(e);
                  }}
                  required
                  disabled={isDisabled("awsId")}
                  className="custom-form-control"
                >
                  <option value="">Select AWS</option>
                  {AWS.map((geo, index) => (
                    <option key={index} value={geo._id}>
                      {geo.accountName}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>
        )}

        <Button
          variant="primary"
          type="submit"
          className="mt-1 custom-form-button text-white"
          style={{ backgroundColor: currentColor }}
        >
          {mode === "create" ? "Add" : "Update"}
        </Button>
      </Form>

      {loading && <Loading loading={"loading"} currentColor={currentColor} />}

      <ToastContainer />
    </>
  );
};

export default ClientForm;
